import { Outlet } from 'react-router-dom';
import Navbar from './components/Navbar';
import NavSidebar from './components/NavSidebar';

const RootLayout = () => {

  return (
    <div className="w-full h-full max-w-[100vw] bg-[url('https://86v8u6agau.ufs.sh/f/A17KOoeuO4h9Dea59Qz5zclKSEsuHo4h2Yk8QTgWLfOdJAvV')] bg-center bg-cover">
      <Navbar />
      <div className="flex flex-row h-full w-full ">
        <NavSidebar />
        <Outlet />
      </div>
    </div>
  )
}

export default RootLayout;
